import { CartLine, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { ICoreContext } from '@msdyn365-commerce/core-internal';
import { loadAttributesForProducts, IProductCatalogPair } from './product-attributes-helpers';
import { hasEVoucherAttribute } from './e-voucher-helpers';

export const validateEVouchersOnCart = async (
    cartLines: CartLine[] | undefined,
    context: ICoreContext,
    products: SimpleProduct[] | undefined,
    eVoucherValidationErrorMessage: string,
    eVoucherIsNotAllowedForGuestErrorMessage: string,
    eVoucherIsMixedWithRegularItemsErrorMessage: string,
    eVoucherAttributeName: string
): Promise<string[]> => {
    if (!eVoucherAttributeName || !cartLines?.length) {
        return [];
    }

    const channelId = context.actionContext.requestContext.apiSettings.channelId;
    const isAuthenticatedUser = context.actionContext.requestContext.user.isAuthenticated;

    const pairs: IProductCatalogPair[] = cartLines
        .filter(l => l.ProductId)
        .map(l => ({
            productId: l.ProductId!,
            catalogId: l.CatalogId ?? 0
        }));

    if (!pairs.length) {
        return [];
    }

    const attrsMap = await loadAttributesForProducts(pairs, channelId, context.actionContext);
    const productNameMap = new Map(products?.map(p => [p.RecordId, p.Name]));

    let hasVoucher = false;
    let hasRegular = false;
    const eVoucherProductsNames: string[] = [];

    pairs.forEach(({ productId }) => {
        const attrs = attrsMap.get(productId) ?? [];

        if (hasEVoucherAttribute(attrs, eVoucherAttributeName)) {
            hasVoucher = true;
            const name = productNameMap.get(productId) ?? '';
            eVoucherProductsNames.push(name);
        } else {
            hasRegular = true;
        }
    });

    if (hasVoucher && !hasRegular) {
        return !isAuthenticatedUser ? [eVoucherIsNotAllowedForGuestErrorMessage] : [];
    }

    if (!hasVoucher && hasRegular) {
        return [];
    }

    return [eVoucherValidationErrorMessage, `${eVoucherIsMixedWithRegularItemsErrorMessage} ${eVoucherProductsNames.join(', ')}`];
};
